import styled from "styled-components";

export const SchoolMatchesSectionContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const SchoolMatchesSectionPanelCard = styled.div.attrs({
  className:
    "overflow-hidden rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_16px_24px_rgba(0,0,0,0.18)]",
})``;

export const SchoolMatchesSectionSectionHeader = styled.div.attrs({
  className: "border-b border-[var(--brand-border)] px-4 py-3",
})``;

export const SchoolMatchesSectionEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolMatchesSectionBodyText = styled.p.attrs({
  className: "mt-1 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const SchoolMatchesSectionSectionBody = styled.div.attrs({ className: "p-4" })``;

export const SchoolMatchesSectionActionButton = styled.button.attrs({
  type: "button",
  className:
    "rounded-full border border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.05)] px-4 py-2 text-sm font-semibold text-[var(--brand-ink)] transition hover:-translate-y-[1px] hover:border-[rgba(240,191,86,0.28)]",
})``;

